import { render, staticRenderFns } from "./SchoolsListPopover.vue?vue&type=template&id=19d08fdc&"
import script from "./SchoolsListPopover.vue?vue&type=script&lang=js&"
export * from "./SchoolsListPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports